import React from "react";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";

// PrivateRoute component to restrict access
const PrivateRoute = ({ user, component: Component }) => {
  return user ? (
    <Component /> // Render the restricted page if the user is authenticated
  ) : (
    <Navigate to="/" /> // Redirect unauthenticated users to LandingPage
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  user: PropTypes.object,
};

export default PrivateRoute;
